import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from './environments/environment';
import { Buffer } from 'buffer';
import {
  registerWindowErrorCapture,
  captureCurrentBuildFingerprint,
  startDeploymentWatch,
  handleChunkLoadError,
} from './app/utils/global-error-handler';

(window as any).Buffer = Buffer;
(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined },
  version: '',
  nextTick: (cb: any) => setTimeout(cb, 0)
};

if (
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
  }

// Mirror authorization credentials and MSAL cache between localStorage and sessionStorage 
// to support seamless multi-tab usage ("Open link in new tab") without forcing re-logins.
if (typeof window !== 'undefined') {
  const isAuthKey = (key: string): boolean => {
    return key === 'session_token' || 
           key === 'access_token' || 
           key === 'Email' || 
           key === 'UserName' || 
           key === 'isLoggedIn' || 
           key === 'tenant_id' || 
           key === 'client_device_id' || 
           key === 'wyber_tenant_msal_config' || 
           key.startsWith('msal.');
  };

  // 1. Sync from localStorage to sessionStorage on initial load of a new tab
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  if (isLoggedIn) {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && isAuthKey(key)) {
        const val = localStorage.getItem(key);
        if (val !== null && sessionStorage.getItem(key) === null) {
          sessionStorage.setItem(key, val);
        }
      }
    }
  }

  // 2. Intercept sessionStorage.setItem to mirror writes to localStorage
  const originalSetItem = sessionStorage.setItem;
  sessionStorage.setItem = function(key, value) {
    originalSetItem.call(sessionStorage, key, value);
    if (isAuthKey(key)) {
      localStorage.setItem(key, value);
    }
  };

  // 3. Intercept sessionStorage.removeItem to mirror deletes to localStorage
  const originalRemoveItem = sessionStorage.removeItem;
  sessionStorage.removeItem = function(key) {
    originalRemoveItem.call(sessionStorage, key);
    if (isAuthKey(key)) {
      localStorage.removeItem(key);
    }
  };

  // 4. Intercept sessionStorage.clear to mirror clear events
  const originalClear = sessionStorage.clear;
  sessionStorage.clear = function() {
    originalClear.call(sessionStorage);
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && isAuthKey(key)) {
        localStorage.removeItem(key);
      }
    }
  };
}

// Register Syncfusion License
registerLicense(environment.syncfusionLicense);

// Capture uncaught window errors + unhandled promise rejections (incl. page-load errors)
// to the backend Error Logs feed.
registerWindowErrorCapture();

// Fingerprint the build this document was served from BEFORE Angular boots (so no
// runtime-injected script can skew it), then watch for newer deployments. Lets a
// route change pick up a new build instead of failing on a deleted lazy chunk.
captureCurrentBuildFingerprint();
startDeploymentWatch();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    // A chunk needed during bootstrap can 404 after a deploy too, and that leaves a
    // blank page with nothing rendered. Recover the same way as a failed route load;
    // if recovery declines (exhausted/offline) fall back to logging as before.
    if (!handleChunkLoadError(err)) {
      console.error(err);
    }
  });
// provideHttpClient(withInterceptors([AuthInterceptor]));
